import React from "react";
import Img from "gatsby-image";
import {graphql, useStaticQuery} from "gatsby";
import "./tiles.css";
import Masonry from 'react-masonry-css'

const Tiles = () => {
    const data = useStaticQuery(graphql`
        query MyQuery {
            allTilinksYaml {
                nodes {
                    title
                    link
                    image {
                        childImageSharp {
                            fluid {
                                aspectRatio
                                sizes
                                base64
                                src
                                srcSet
                            }
                        }
                    }
                }
            }
        }
    `)
    return (
        <Masonry
            breakpointCols={3}
            className="masonry-grid"
            columnClassName="masonry-column">
        {
            data.allTilinksYaml.nodes.map(node => (
                <div class="tile">
                <a href={node.link}>
                <Img fluid={node.image.childImageSharp.fluid} className="tile-picture"/>
                <h3>{node.title}</h3>
                </a>
                </div>
            ))
        }
        </Masonry>
    )
};

export default Tiles;